export default {
  // pullSuccessful.vue - Pull Success Dialog
  pullSuccessful: {
    dialogTitle: "Notification",
    tipText:
      "Successfully retrieved the latest 10,000 transaction records for this address",
    addressLabel: "Address:",
    transactionTimeRange: "Transaction Time Range:",
    warningPulling: "Pulling full data, please be patient",
    cancelBtn: "Cancel",
    pullAllBtn: "Pull All",
    pullNotifyTitle: "Notification",
    pullNotifyMessage:
      "Data is being fetched. This may take some time. Please be patient and check node details later",
  },

  // nodedetailTip.vue - Node Detail Tip
  nodeDetailTip: {
    transactionData: "Transaction Data:",
    fullData: "Full Data",
    recentUpdate: "Recent Update:",
    limitedData: "Transaction data limited to recent 10,000 records",
    syncAll: "Sync All",
    syncing: "Syncing",
    syncFailed: "Sync Failed",
    retry: "Retry",
    tooltipContent:
      "Data is being fetched. This may take some time. Please be patient and check node details later",
    notifyTitle: "Notification",
    notifyMessage:
      "Data is being fetched. This may take some time. Please be patient and check node details later",
  },

  // datasuccess.vue - Data Sync Complete Dialog
  dataSuccess: {
    syncCompleteText: "Historical data synchronization complete",
    addressLabel: "Address:",
    transactionTimeRange: "Transaction Time Range:",
    warningTip:
      "Collapse expanded nodes first, then re-expand to get the latest transaction data",
    confirmBtn: "Confirm",
  },
};
